module.exports = __webpack_public_path__ + "static/media/WRC8.9d32bac.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/vidio/WRC8.mp4
// module id = MX/x
// module chunks = 0